import { Checkbox } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateRequest } from "../../../../store/actions/deviceExplorer";

const toFriendlyLabel = (key) =>
  key
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());

function ViewDeviceExplorerAttribute() {
  const dispatch = useDispatch();
  const deviceid = useSelector(state=>state.currentid);
  const checkboxOptions = useSelector((state) => state.singleDeviceHeader.isBLE
    ? state.singleDeviceHeader.bleAttributes
    : state.singleDeviceHeader.gatewayAttributes
  );
  const seletedAttributes = useSelector((state) => state.deviceExplorer.seletedAttributes);
  const onChange = (checkedValues) => {
    dispatch(updateRequest({
      seletedAttributes: checkedValues
    }))
  };

  return (
    <div className="d-flex flex-sm-column flex-md-row justify-content-start align-items-center pt-3 pb-2">
      <span className="font-face-vzw" style={{ fontSize: "16px" }}>
        Attributes:
      </span>
      <div className="mx-3">
        <Checkbox.Group
          options={checkboxOptions.map(opt => ({ ...opt, label: toFriendlyLabel(opt.label ?? opt.value) }))}
          value={seletedAttributes}
          onChange={onChange}
        />
      </div>
    </div>
  );
}

export default ViewDeviceExplorerAttribute;
